import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Heading } from '../../NavMenu';
import SpendingReportTabPanel from './SpendingReportTabPanel';
import Filter from './Filter';
import Zoomed from './Zoomed';

import { FilterAction, FilterUserSpendingReportState } from './../../../interface/MyInterfaces';
import { loadSharedLink } from './../../../actions/FilterPageActions';

import { ApplicationState } from '../../../reducers/Index';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ViewReportModal from '../ViewReportModal';

// import event tracking log
import { withUserActionTracker } from './../../../sharedUtilities/UserActionTracker';


class SpendingReport extends React.Component<FilterAction & FilterUserSpendingReportState & RouteComponentProps<{}>, {}> {
    componentDidMount() {
        if (this.props.match.params !== undefined &&
            this.props.match.params["link_id"] !== undefined &&
            this.props.match.params["p1"] !== undefined &&
            this.props.match.params["p2"] !== undefined) {

            this.props.loadSharedLink(this.props.match.params["link_id"],
                this.props.match.params["p1"],
                this.props.match.params["p2"])
        }

    }

    public render() {
        var loadSharedLink = false;

        //console.log(this.props.UserState.report_display_id)

        const sharedLinkPageOnLoad = this.props.match.params !== undefined && this.props.match.params["link_id"] !== undefined && this.props.match.params["p1"] !== undefined && this.props.match.params["p2"] !== undefined;
        if (sharedLinkPageOnLoad) {
            loadSharedLink = true;
        }

        return <div className="SpendingReport">
            {!loadSharedLink && <Filter />}
            {sharedLinkPageOnLoad && (!this.props.match.params["ne"]) ? <ViewReportModal filetype={"Spending"} /> : null}
            <Zoomed />
            <SpendingReportTabPanel handleTabClickFromParent={this.props.handleTabClickFromParent} />                
        </div>;
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadSharedLink: loadSharedLink
        }, dispatch
    )
}

const mapStateToProps = (state: ApplicationState) => ({
    FilterState: state.filterProperties,
    UserState: state.userProperties
});


export default connect(
    mapStateToProps, // Selects which state properties are merged into the component's props
    matchDispatchToProps
)(withUserActionTracker(SpendingReport, "Spending Report", "landing page"));